import '../keyword/applied_keywords_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.AppliedSurveyKeywordFilterView extends Monitoring.Views.SocialContents.Filters.AppliedKeywordsView

  initialize: (@options = {}) ->
    super(@options)
    @name = @options.name
    @alias = @options.alias
    @survey = @options.survey

  clear: =>
    @searchQuery.resetSurveyKeyword(@name, @survey)
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  removeFilter: (value, list) ->
    @searchQuery.removeSurveyKeyword('primary_keywords', value, @name, @survey)   if list == @withPrefix('primary_keywords')
    @searchQuery.removeSurveyKeyword('secondary_keywords', value, @name, @survey) if list == @withPrefix('secondary_keywords')
    @searchQuery.removeSurveyKeyword('excluded_keywords', value, @name, @survey)  if list == @withPrefix('excluded_keywords')

  _get: (group) ->
    @searchQuery.getSurveyKeywords(group, @name, @survey)
